module.exports = __webpack_public_path__ + "img/baby-pink.968a8af0.svg";